import { Advert } from './Advert';

function newAdvert(): typeof Advert.new {
  return Advert.new;
}

export { newAdvert };
